module.exports = __webpack_public_path__ + "static/media/u30_premium_contract6.0af40b48.webp";